module.exports = __webpack_public_path__ + "static/img/h5.75c191a9.jpg";